let state = {
    name: '苗',
    age: 121,
    done: '1',
    number: 10000
}

export default state
